import React from "react";
import PageTemplate from "components/templates/PageTemplate";
import Questions from "components/forms/Questions";

const data = [
  {
    title: "Ինչ Տվյալներ ենք Հավաքում",
    desc: "Օգտագործելով Prognos-ը, մենք կարող ենք հավաքել հետևյալ տվյալները՝",
    subItems: [
      `Գրանցման տվյալներ – Ձեր անունը, էլ. հասցեն և այլ տվյալներ, որոնք տրամադրում եք հաշիվ ստեղծելիս։`,
      `Օգտագործման տվյալներ – Կայքի օգտագործման հետ կապված տեղեկություններ, ինչպիսիք են ձեր գնահատականները, վարկանիշային գործունեությունը և փոխազդեցությունները։`,
      `Տեխնիկական տվյալներ – IP հասցե, բրաուզերի տեսակը, սարքի տվյալներ և այլ տեխնիկական մանրամասներ։`,
    ],
  },
  {
    title: "Ինչու ենք Հավաքում Տվյալները",
    desc: "Մենք օգտագործում ենք ձեր տվյալները՝",
    subItems: [
      `Կայքի ճիշտ գործելու և օգտատերերի վարկանիշային համակարգը պահպանելու համար։`,
      `Օգտատերերի փորձը բարելավելու և անհատականացված առաջարկներ տրամադրելու նպատակով։`,
      `Անվտանգությունն ապահովելու, խարդախությունը կանխարգելելու և մեր քաղաքականություններին համապատասխանությունը վերահսկելու համար։`,
    ],
  },
  {
    title: "Ինչպես ենք Պաշտպանում Ձեր Տվյալները",
    subItems: [
      `Ձեր տվյալները պահպանվում են անվտանգ սերվերներում՝ պաշտպանված ժամանակակից կոդավորման և անվտանգության միջոցներով։`,
      `Չենք կիսում ձեր անձնական տվյալները երրորդ կողմերի հետ առանց ձեր համաձայնության, բացառությամբ օրենքով պահանջվող դեպքերի։`,
      `Կատարում ենք պարբերական անվտանգության ստուգումներ՝ տվյալների պաշտպանությունը երաշխավորելու համար։`,
    ],
  },
  {
    title: "Կպահպանե՞նք Ձեր Տվյալները",
    subItems: [
      `Ձեր տվյալները կպահպանվեն այնքան ժամանակ, որքան անհրաժեշտ է մեր ծառայությունների տրամադրման և օրենսդրական պահանջների պահպանման համար։`,
      `Դուք կարող եք ցանկացած պահի պահանջել ձեր հաշվի և տվյալների հեռացում։`,
    ],
  },
  {
    title: "cookies և Հետագծման Տեխնոլոգիաներ",
    subItems: [
      `Prognos-ը կարող է օգտագործել կուկիներ (cookies)՝ վեբկայքի աշխատանքը բարելավելու, վերլուծական տվյալներ հավաքելու և անհատականացված բովանդակություն տրամադրելու նպատակով։`,
      `Դուք կարող եք կառավարել կամ անջատել կուկիները ձեր բրաուզերի կարգավորումներում։`,
    ],
  },
  {
    title: "Ձեր Իրավունքները",
    desc: "Դուք իրավունք ունեք՝",
    subItems: [
      `Մուտք գործել ձեր անձնական տվյալները և պահանջել դրանց փոփոխում կամ հեռացում։`,
      `Մերժել որոշակի տվյալների մշակումը, եթե այն չի պահանջվում ծառայության մատուցման համար։`,
      `Պահանջել ձեր տվյալների պատճենը կամ դրանց փոխանցումը այլ ծառայությանը։`,
    ],
  },
];

const PrivacyPolicy = () => {
  return (
    <div className="mb-[24px]">
      <PageTemplate
        title="Գաղտնիության Քաղաքականություն"
        data={data}
        desc="Բարի գալուստ Prognos։ Ձեր գաղտնիությունը մեզ համար կարևոր է։
Այս քաղաքականությունը նկարագրում է, թե ինչպես ենք մենք հավաքում, օգտագործում և պաշտպանում ձեր անձնական տվյալները։"
      >
        <Questions />
      </PageTemplate>
    </div>
  );
};

export default PrivacyPolicy;
